module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('md-card', {
    attrs: {
      "title": "Danh sách khối lớp",
      "backgroundColor": "purple"
    }
  }, [_c('span', {
    staticClass: "headerRight"
  }, [_c('i', {
    staticClass: "material-icons list-action",
    on: {
      "click": _vm.onItemAdd
    }
  }, [_vm._v("add")])]), _c('md-table', {
    attrs: {
      "data": _vm.grades,
      "columns": _vm.columns
    },
    on: {
      "onItemDelete": _vm.onItemDelete,
      "onItemEdit": _vm.onItemEdit
    }
  })], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d45e088","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Grade/index.vue
// module id = 1577
// module chunks = 0